// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"_M-z","carouselContainer":"aN-z"};